import { useLocation } from "react-router-dom";

export default function FooterPagesNavigation({ pages, onEnd, textEnd = "Finaliser", endDisable, onClickDisable, textDisable = "" }) {
  const hash = useLocation().hash;

  return (
    <>
      <div className="flex items-center fixed w-full z-10 bottom-0 justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
        <div className="flex w-full sm:flex-1 justify-center items-center">
          <nav className="isolate inline-flex -space-x-px rounded-md max-w-xl" aria-label="Pagination">
            <a
              href={"#" + (parseInt(hash.split("#")[1]) - 1 < 1 ? 1 : parseInt(hash.split("#")[1]) - 1).toString()}
              className={
                "relative font-bold inline-flex items-center justify-center space-x-4 rounded-md border z-20 px-4 py-2 text-sm focus:z-20 w-1/3 " +
                (parseInt(hash.split("#")[1]) - 1 < 1
                  ? "border-palette-light-green bg-gray-50 text-palette-light-green"
                  : "border-palette-green bg-white  text-palette-green hover:bg-gray-50")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                aria-hidden={true}
                className="w-5 h-5"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
              <span>Précédent</span>
            </a>
            <div className="w-1/3 lg:w-64 flex justify-center items-center">
              {parseInt(hash.split("#")[1])}/{pages}
            </div>
            {/* {buttons} */}
            {parseInt(hash.split("#")[1]) >= pages && (
              <>
                <div className="flex items-center space-x-2 w-1/3">
                  <button
                    disabled={endDisable}
                    onClick={onEnd}
                    className={
                      "relative font-bold inline-flex items-center rounded-md border z-20 px-4 py-2 text-sm focus:z-20 " +
                      (endDisable
                        ? "border-palette-light-green bg-gray-50 text-palette-light-green hidden sm:block"
                        : "border-palette-green bg-white  text-palette-green hover:bg-gray-50")
                    }
                  >
                    {textEnd}
                  </button>
                  {endDisable && <p onClick={onClickDisable} className="text-center cursor-pointer hover:underline text-sm font-semibold text-red-300">{textDisable}</p>}
                </div>
              </>
            )}
            {parseInt(hash.split("#")[1]) < pages && (
              <a
                href={"#" + (parseInt(hash.split("#")[1]) + 1).toString()}
                className="relative font-bold inline-flex items-center justify-center space-x-4 rounded-md border w-1/3 z-20 px-4 py-2 text-sm focus:z-20 border-palette-green bg-white  text-palette-green hover:bg-gray-50"
              >
                <span>Suivant</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  aria-hidden={true}
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </a>
            )}
          </nav>
        </div>
      </div>
    </>
  );
}
